"use strict";

angular.module("portal.lookup").controller("ServiceLookup", [
    "$scope",
    "$state",
    "$stateParams",
    "$rootScope",
    "Enterprise",
    "EnterprisePublicLookup",
    "Format",
    "Services",
    "Users",
    "Vehicles",
    function(
        $scope,
        $state,
        $stateParams,
        $rootScope,
        Enterprise,
        EnterprisePublicLookup,
        Format,
        Services,
        Users,
        Vehicles
    ) {
        $scope.loading = true;
        $scope.looking_up = false;
        $scope.promises = [];
        $scope.parameters = {
            enterpriseID: $rootScope.enterpriseID
        };
        $scope.license_label = "License";
        $scope.show_search_results = false;
        $scope.filters = [];
        $scope.search_columns = [];
        $scope.search_header_columns = [];
        $scope.vehicle_columns = [];
        $scope.services = [];
        $scope.reverse = false;

        $scope.currentPage;
        $scope.numPerPage = 10;
        $scope.perPages = [
            { id: 10, name: 10 },
            { id: 15, name: 15 },
            { id: 20, name: 20 },
            { id: 25, name: 25 },
            { id: 50, name: 50 }
        ];
        $scope.record_count = 0;
        $scope.filterFound = false;
        $scope.messages = ["Please enter a value into one of the filter fields to search."];

        //recaptcha vars
        $scope.recaptchaMessage = ($scope.enterprise.recaptcha_site_key_v3 == null && $scope.enterprise.recaptcha_enabled) ? "There was an issue loading recaptcha, please try again or contact system administrator." : ""; //message to display

        if (!$stateParams.lookup_object) {
            $scope.lookup_object = {
                enterprise_id: $rootScope.enterpriseID,
                records_offset: 0,
                records_total: 10,
                sort_fields: null,
                recaptcha_passed: $scope.enterprise.recaptcha_enabled ? false : true, //to gatekeep intended function, make true if recaptcha is off, if passed from the base lookup page, will have already checked recaptcha

            };
        } else {
            $scope.lookup_object = $stateParams.lookup_object; // this will contain data like first_name, etc. from base lookup
            $scope.lookup_object.enterprise_id = $rootScope.enterpriseID;
            if (!$scope.lookup_object.records_offset)
                $scope.lookup_object.records_offset = 0;
            if (!$scope.lookup_object.records_total)
                $scope.lookup_object.records_total = 10;
            if (!$scope.lookup_object.sort_fields)
                $scope.lookup_object.sort_fields = null;
            if (!$scope.lookup_object.sort_fields)
                $scope.lookup_object.sort_direciton = " asc";

            getCount(search); // state params are not null, first time around, need to get count
        }

        $scope.lookup_object.from_search = true;

        $scope.currentState = $state.current.name;
        if ($stateParams.priorState) {
            $scope.priorState = $stateParams.priorState;
        }

        // Make sure we have the enterprise details
        if ($rootScope.enterprise != null) {
            $scope.enterprise = $rootScope.enterprise;
            $scope.loading = false;
        } else {
            if ($rootScope.userAccount !== null) {
                Enterprise.get($scope.parameters).then(function(result) {
                    $scope.enterprise = result;
                    $scope.loading = false;
                });
            } else {
                $scope.parameters.isPortal = true;
                Enterprise.getLess($scope.parameters).then(function(result) {
                    $scope.enterprise = result;
                    $scope.loading = false;
                });
            }
        }

        // Get the entity labels
        $scope.serviceLabel = $scope.enterprise.serviceLabels["SERVICE"];

        // Get the service lookup filters columns
        EnterprisePublicLookup.get({
            enterpriseId: $rootScope.enterpriseID,
            code: "filter",
            entityType: "service"
        }).then(function(result) {
            if (result != null) {
                $scope.filters = result;
                $scope.filtersAlias = [];
                result.forEach(function (filter) {
                    $scope.filtersAlias.push(filter.alias);
                });
                $scope.filterFound = $scope.filtersAlias.some(function (name) {
                    return $scope.lookup_object.hasOwnProperty(name) && $scope.lookup_object[name] && $scope.lookup_object[name] != '';
                });
            }
        });

        // get the service lookup search columns
        EnterprisePublicLookup.get({
            enterpriseId: $rootScope.enterpriseID,
            code: "search",
            entityType: "service"
        }).then(function(result) {
            $scope.search_columns = [];
            $scope.search_header_columns = [];
            $scope.search_columns_vehicles = [];
            $scope.vehicle_columns = []; // the service lookup does not have a drop down (yet) so no need to use these
            $scope.search_columns_service_users = [];
            $scope.service_user_columns = [];
            $scope.certification_columns = [];
            $scope.cert_attribute_columns = [];

            if (result != null) {
                $scope.search_header_columns = result
                    .filter(function(c) {
                        // column may be a header column but not sortable, in that case sort button is removed
                        return c.sortable && c.alias != "service_name"; // taking care of the service name by itself as it includes a link...kinda dumb
                    })
                    .slice(0, 7); // let's just get the first 7 columns

                $scope.search_columns_singular = result.filter(function(c) {
                    // drop down detail columns
                    return c.singular_relationship && !c.sortable;
                });

                $scope.search_columns_vehicles = result.filter(function(c) {
                    return (
                        !c.singular_relationship && c.table_name == "vehicles"
                    );
                });

                $scope.search_columns_vehicles.forEach(function(c) {
                    $scope.vehicle_columns.push({
                        label: c.label,
                        field: c.alias,
                        type: c.format_type
                    });
                });

                $scope.search_columns_service_users = result.filter(function(
                    c
                ) {
                    return (
                        !c.singular_relationship &&
                        c.table_name == "service_users"
                    );
                });
                $scope.search_columns_certifications = result.filter(function (c) {
                    return (
                        !c.singular_relationship && c.category == "Certification List"
                    );
                });

                $scope.search_columns_certifications.forEach(function (column) {
                    // create columns for list directive
                    $scope.certification_columns.push({
                        label: column.label,
                        field: column.alias,
                        type: column.format_type,
                        revertTimeZone:
                            column.format_type == "date"
                                ? column.field.toLowerCase() == "issue_date" ||
                                    column.field.toLowerCase() ==
                                    "expiration_date" || column.field.toLowerCase() == "initial_issue_date"
                                    ? true
                                    : false
                                : undefined
                    });
                });

                // create columns for list directive
                $scope.cert_attribute_columns.push({
                    label: "Attribute Name",
                    field: "name",
                    type: "string"
                });

                // create columns for list directive
                $scope.cert_attribute_columns.push({
                    label: "Attribute Value",
                    field: "value",
                    type: "string"
                });

                $scope.search_columns_service_users.forEach(function(c) {
                    $scope.service_user_columns.push({
                        label: c.label,
                        field: c.alias,
                        type: c.format_type,
                        link:
                            c.field == "full_name"
                                ? {
                                      // conditionally add link property
                                      state: "portal.menus.userlookupdetail",
                                      params: [
                                          {
                                              name: "id",
                                              field: "id"
                                          },
                                          {
                                              name: "priorState",
                                              field: "priorState"
                                          },
                                          {
                                              name: "lookup_object",
                                              field: "lookup_object"
                                          }
                                      ]
                                  }
                                : undefined,
                        revertTimeZone:
                            c.format_type == "date"
                                ? c.field.toLowerCase() == "issue_date" ||
                                  c.field.toLowerCase() == "expiration_date"
                                    ? true
                                    : false
                                : undefined
                    });
                });
            }
        });

        function toggleService(service) {
            service.isOpen = !service.isOpen;
            if (service.isOpen) {
                if (service.alert_count > 0) {
                    Services.getServiceAlerts({
                        serviceID: service.id,
                        is_public: true
                    }).then(function(result) {
                        service.alerts = result;

                        if (
                            service.alerts != null &&
                            service.alerts.length > 0
                        ) {
                            service.alerts_concat = "";
                            service.alerts.forEach(function(alert) {
                                // slightly faster than using .reduce
                                service.alerts_concat += ", " + alert.message;
                            });
                        }
                    });
                }

                if (
                    $scope.search_columns_vehicles.length > 0 &&
                    !service.vehicles
                ) {
                    service.service_vehicles_list_loading = true;
                    Vehicles.get({
                        service_id: service.id,
                        for_lookup: true,
                        enterpriseID: $rootScope.enterpriseID
                    }).then(function(result) {
                        if (result != null) {
                            service.vehicles = result;
                        }
                        service.service_vehicles_list_loading = false;
                    });
                }

                if (
                    $scope.search_columns_certifications.length > 0 &&
                    !service.certifications
                ) {
                    service.certifications_list_loading = true;
                    Services.getServiceCertifications(
                        service.id,
                        false,
                        $rootScope.enterpriseID
                    ).then(function (result) {
                        service.certifications = result;
                        service.certifications_list_loading = false;
                    });
                }

                if (
                    $scope.search_columns_service_users.length > 0 &&
                    !service.service_users
                ) {
                    service.service_users_list_loading = true;
                    Users.getPublicSearchUser({
                        externalOnly: true,
                        service_id: service.id,
                        forService: true,
                        inactiveServiceUsers: false,
                        forServiceLookup: true,
                        enterpriseID: $rootScope.enterpriseID
                    }).then(function(result) {
                        if (result != null) {
                            service.service_users = result.map(function(user) {
                                user.priorState = $state.current.name;
                                user.lookup_object = $scope.lookup_object;
                                return user;
                            });
                        }
                        service.service_users_list_loading = false;
                    });
                }
            }
        }

        $scope.toggleService = toggleService;

        function getCount(search) {
            $scope.looking_up = true;
            Services.getServiceLookupCount($scope.lookup_object).then(function(
                result
            ) {
                $scope.record_count = result;
                if (search) {
                    search();
                } else {
                    $scope.looking_up = false;
                }
            });
        }

        $scope.getCount = getCount;

        function search() {
            $scope.looking_up = true;
            Services.PublicLookupService($scope.lookup_object).then(function(result) {
                if (result != null) {
                    $scope.services = result.map(function(service) {
                        service.isOpen = false;

                        service.websiteUrl = Format.url(service.website);

                        return service;
                    });
                }

                $scope.looking_up = false;
                $scope.show_search_results = true;
            });
        }

        $scope.search = search;

        $scope.recaptchaSubmit = function () {
            $scope.looking_up = true; //if there is a loading type var for display
            if ($scope.enterprise.recaptcha_enabled && $scope.lookup_object.recaptcha_passed != true) {
                if ($scope.enterprise.recaptcha_site_key_v3 != null) {
                    grecaptcha.ready(function () {
                        try {
                            grecaptcha.execute($scope.enterprise.recaptcha_site_key_v3, { action: 'publicUserLookup' }).then(function (token) { //execute returns a token
                                return Enterprise.getRecaptchaResponse("publicUserLookup", token) // send action, token, score to pass over to server for validation, returns a response object
                            }).then(function (response) { // take the response and update variables
                                if (response.success == false) {
                                    $scope.recaptchaMessage = 'Recaptcha Error: ' + response.error;
                                    $scope.looking_up = false; //if there is a loading type var for display
                                } else {
                                    $scope.recaptchaMessage = "";
                                };
                            }).then(function () {
                                if ($scope.recaptchaMessage == "") {
                                    $scope.getCount(search); //put function here if passed to continue normal "submit" is recaptcha passed
                                } else {
                                    $scope.$apply(); //update dom so error message displays if recaptcha failed
                                };
                            }).catch(function (response) {
                                // handle error
                            });
                        } catch (error) {
                            $scope.recaptchaMessage = "There was an issue loading recaptcha, please try again or contact system administrator.";
                            $scope.looking_up = false; //if there is a loading type var for display
                        }
                    });
                } else {
                    return;
                }
            } else {
                $scope.getCount(search); //put function here to continue normal "submit" if recaptcha is turned off
            };
        };


        function clearFilter() {
            $scope.filters.forEach(function(filter) {
                delete $scope.lookup_object[filter.alias];
            });

            $scope.services = [];
            $scope.record_count = 0;
        }

        $scope.clearFilter = clearFilter;

        function sort(column) {
            $scope.reverse = !$scope.reverse;
            $scope.lookup_object.sort_fields = column.alias;
            $scope.lookup_object.sort_direction = $scope.reverse
                ? " asc"
                : "desc";
            $scope.search();
        }

        $scope.sort = sort;

        $scope.determineClasses = function(index, length, column, record) {
            var classes = "";

            var value = Math.floor(12 / length);
            var mod = 12 % length;
            if (index < mod) {
                value += 1;
            }
            classes = "col-xs-" + value;

            return classes;
        };

        $scope.setCurrentPage = function(page) {
            $scope.lookup_object.records_offset = page * $scope.numPerPage;
            $scope.search();
            $scope.currentPage = angular.copy($scope.pages[page]);
        };

        $scope.setNumPerPage = function(numPerPage) {
            $scope.numPerPage = numPerPage;
            $scope.lookup_object.records_total = numPerPage;
            $scope.setPages($scope.record_count);
            $scope.search();
        };

        $scope.numOfPages = function(length) {
            return Math.ceil(length / $scope.numPerPage) - 1;
        };

        $scope.setPages = function(length) {
            $scope.pages = [];

            if (length > 0) {
                var i = 0;
                for (i = 0; i <= $scope.numOfPages(length); i++) {
                    $scope.pages.push({ id: i, name: i + 1 });
                }
            } else {
                $scope.pages.push({ id: 0, name: 0 });
            }

            $scope.lookup_object.records_offset = 0;
            $scope.currentPage = angular.copy($scope.pages[0]);
        };

        $scope.$watch("record_count", function(length) {
            $scope.setPages(length);
        });

        // Ensure there is a filter with a value in the lookup
        $scope.$watch("lookup_object", function () {
            if ($scope.filtersAlias && $scope.filtersAlias.length > 0) {
                $scope.filterFound = $scope.filtersAlias.some(function (name) {
                    return $scope.lookup_object.hasOwnProperty(name) && $scope.lookup_object[name] && $scope.lookup_object[name] != '';
                });
            }
        }, true);
    }
]);
